module.exports = __webpack_public_path__ + "img/endDates.c6ab6305.svg";